(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nutri-reviews')) {
    customElements.define('nutri-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const on = (node, event, fn) => node.addEventListener(event, fn, { signal });
        this.viewport = this.querySelector('.nr__viewport');
        this.track = this.querySelector('.nr__track');
        this.group = this.querySelector('.nr__group:not([aria-hidden])');
        this.group.replaceChildren();
        this.dialog = this.querySelector('dialog');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.reasons = new Set();
        let reviews;
        try {
          const feed = JSON.parse(this.querySelector('[data-reviews]').content.textContent);
          reviews = feed.all_reviews.reviews;
          if (!Array.isArray(reviews)) throw new Error('Missing public review feed');
        } catch {
          this.empty();
          return;
        }
        const seen = new Set();
        reviews = reviews.filter(r => r.uuid && !seen.has(r.uuid) && seen.add(r.uuid) && Number(r.rating) >= 1 && Number(r.rating) <= 5 && (r.body || r.title || r.pictures_urls?.length))
          .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at))
          .slice(0, Number(this.dataset.limit) || 20);
        if (!reviews.length) { this.empty(); return; }
        for (const review of reviews) this.group.append(this.card(review));
        this.addEventListener('error', e => {
          const img = e.target;
          if (!(img instanceof HTMLImageElement)) return;
          img.classList.remove('nr__image--customer');
          const next = img.dataset.fallback || img.dataset.logo;
          if (next && img.src !== next) {
            img.dataset.fallback = '';
            if (next === img.dataset.logo) img.dataset.logo = '';
            img.src = next;
          }
        }, { capture: true, signal });
        on(this.viewport, 'pointerenter', e => { if (e.pointerType === 'mouse') this.hold('hover', true); });
        on(this.viewport, 'pointerleave', e => { if (e.pointerType === 'mouse') this.hold('hover', false); });
        let drag = null;
        let blockNextClick = false;
        const endDrag = e => {
          if (drag && e.pointerId !== undefined && e.pointerId !== drag.id) return;
          if (drag && this.viewport.hasPointerCapture(drag.id)) this.viewport.releasePointerCapture(drag.id);
          drag = null;
          this.viewport.classList.remove('is-dragging');
          if (this.reasons.has('touch')) this.hold('touch', false);
        };
        on(this.viewport, 'pointerdown', e => {
          blockNextClick = false;
          if (e.button !== 0 || drag) return;
          this.hold('touch', true);
          if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
          drag = { id: e.pointerId, x: e.clientX, distance: 0 };
          this.viewport.classList.add('is-dragging');
        });
        on(this.viewport, 'pointermove', e => {
          if (!drag || e.pointerId !== drag.id) return;
          if (!(e.buttons & 1)) { endDrag(e); return; }
          const distance = e.clientX - drag.x;
          drag.x = e.clientX;
          drag.distance += Math.abs(distance);
          this.position = this.viewport.scrollLeft - distance;
          this.normalize();
          if (drag.distance > 4) {
            this.viewport.setPointerCapture(e.pointerId);
            blockNextClick = true;
            e.preventDefault();
          }
        });
        on(window, 'pointerup', endDrag);
        on(window, 'pointercancel', endDrag);
        on(this.viewport, 'lostpointercapture', endDrag);
        on(window, 'blur', endDrag);
        on(this.viewport, 'dragstart', e => e.preventDefault());
        this.viewport.addEventListener('click', e => {
          if (!blockNextClick || e.detail === 0) return;
          e.preventDefault();
          e.stopPropagation();
          blockNextClick = false;
        }, { capture: true, signal });
        on(this.viewport, 'touchstart', () => this.hold('gesture', true));
        on(this.viewport, 'touchend', () => this.hold('gesture', false));
        on(this.viewport, 'touchcancel', () => this.hold('gesture', false));
        on(this.viewport, 'wheel', () => { this.hold('scroll', true); this.hold('scroll', false); });
        on(this.viewport, 'scroll', () => {
          if (Math.abs(this.viewport.scrollLeft - this.written) < 1) return;
          this.hold('scroll', true);
          this.position = this.viewport.scrollLeft;
          this.normalize();
          this.hold('scroll', false);
        });
        on(this.viewport, 'keydown', e => {
          if (e.code === 'Space' && e.target === this.viewport) {
            e.preventDefault();
            this.hold('manual', !this.reasons.has('manual'));
          }
        });
        on(this.viewport, 'focusin', e => { if (e.target.matches(':focus-visible')) this.hold('focus', true); });
        on(this.viewport, 'focusout', e => { if (!this.viewport.contains(e.relatedTarget)) this.hold('focus', false); });
        on(this, 'click', e => {
          const body = e.target.closest('.nr__body');
          if (!body) return;
          this.dialog.querySelector('h3').textContent = body.dataset.author;
          this.dialog.querySelector('.nr__full-body').textContent = body.textContent;
          this.hold('dialog', true);
          this.dialog.showModal();
        });
        on(this.querySelector('.nr__close'), 'click', () => this.dialog.close());
        on(this.dialog, 'close', () => this.hold('dialog', false));
        on(this.reduced, 'change', () => this.layout());
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.viewport);
        this.intersection = new IntersectionObserver(entries => {
          this.offscreen = !entries[0].isIntersecting;
          this.sync();
        });
        this.intersection.observe(this);
        on(document, 'visibilitychange', () => this.sync());
        this.layout();
      }
      empty() {
        const editor = this.querySelector('.nr__editor');
        if (editor) editor.hidden = false;
        else this.hidden = true;
      }
      safeUrl(value, product = false) {
        try {
          const url = new URL(value, location.origin);
          if (!value || !['https:', 'http:'].includes(url.protocol)) return '';
          if (product && (url.origin !== location.origin || !url.pathname.includes('/products/'))) return '';
          return url.href;
        } catch { return ''; }
      }
      card(review) {
        const card = this.querySelector('[data-card]').content.firstElementChild.cloneNode(true);
        const product = !review.is_shop_review;
        const productUrl = product && review.product_in_store !== false ? this.safeUrl(review.product_url, true) : '';
        const pill = card.querySelector('.nr__pill');
        if (product && review.product_title && this.dataset.pills === 'true') {
          pill.hidden = false;
          if (productUrl) pill.href = productUrl;
          pill.textContent = review.product_title;
        }
        const photo = this.safeUrl(review.pictures_urls?.[0]?.original);
        const productImage = product ? this.safeUrl(review.product_pictures_url || review.product_variant_image_url) : '';
        const logo = this.safeUrl(this.dataset.logo);
        const img = card.querySelector('img');
        img.src = photo || productImage || logo;
        img.alt = photo ? `${review.reviewer_name}: ${review.product_title || this.dataset.shop}` : productImage ? review.product_title : this.dataset.shop;
        img.classList.toggle('nr__image--customer', Boolean(photo));
        img.dataset.fallback = productImage !== img.src ? productImage : '';
        img.dataset.logo = logo !== img.src ? logo : '';
        const rating = Number(review.rating);
        card.querySelector('.nr__rating').textContent = '★'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating));
        card.querySelector('.nr__rating').setAttribute('aria-label', `${rating} / 5`);
        const body = card.querySelector('.nr__body');
        body.textContent = [review.title, review.body].filter(Boolean).join('\n');
        body.dataset.author = review.reviewer_name;
        card.querySelector('.nr__author span').textContent = review.reviewer_name;
        card.querySelector('.nr__verified').hidden = !(review.verified_buyer === true && this.dataset.verified === 'true');
        return card;
      }
      layout() {
        const phase = this.period ? ((this.viewport.scrollLeft - this.start) % this.period + this.period) % this.period / this.period : 0;
        this.track.querySelectorAll('[aria-hidden]').forEach(node => node.remove());
        this.period = this.group.getBoundingClientRect().width;
        if (!this.period) return;
        const copies = Math.ceil(this.viewport.clientWidth / this.period) + 1;
        for (let i = 0; i < copies * 2; i++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach(node => node.tabIndex = -1);
          if (i < copies) this.track.prepend(clone);
          else this.track.append(clone);
        }
        this.start = copies * this.period;
        this.position = this.start + phase * this.period;
        this.normalize();
        this.sync();
      }
      normalize() {
        if (!this.period) return;
        this.position = this.start + ((this.position - this.start) % this.period + this.period) % this.period;
        this.viewport.scrollLeft = this.position;
        this.written = this.viewport.scrollLeft;
      }
      hold(reason, active) {
        clearTimeout(this.resumeTimer);
        if (active) this.reasons.add(reason);
        else this.reasons.delete(reason);
        this.waiting = true;
        this.sync();
        if (!this.reasons.size) this.resumeTimer = setTimeout(() => { this.waiting = false; this.sync(); }, 2000);
      }
      sync() {
        cancelAnimationFrame(this.frame);
        if (!this.period || this.waiting || this.reasons.size || this.offscreen || document.hidden || this.reduced.matches) return;
        let previous;
        const tick = time => {
          const elapsed = previous === undefined ? 0 : Math.min(time - previous, 50);
          previous = time;
          const direction = this.dataset.direction === 'left' ? 1 : -1;
          this.position += direction * (Number(this.dataset.speed) || 40) * elapsed / 1000;
          this.normalize();
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.resumeTimer);
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const selector = '[data-nutri-infinite-scroll]';

    const revealItem = (item) => {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      item.removeAttribute('data-cascade');
      item.style.removeProperty('--animation-order');
    };

    const loadNextPage = async (sentinel, observer) => {
      if (sentinel.dataset.loading === 'true') return;

      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl) {
        sentinel.remove();
        return;
      }

      sentinel.dataset.loading = 'true';
      observer.unobserve(sentinel);

      try {
        const response = await fetch(nextUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error(`Unable to load ${nextUrl}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const currentGrid = sentinel.closest('collection-component')?.querySelector('#product-grid');
        const nextGrid = documentFragment.querySelector('#product-grid');
        const nextSentinel = documentFragment.querySelector(selector);

        if (!currentGrid || !nextGrid) throw new Error('Product grid was not found');

        Array.from(nextGrid.children).forEach((item) => {
          revealItem(item);
          currentGrid.appendChild(item);
        });

        if (nextSentinel?.dataset.nextUrl) {
          sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
          const fallbackLink = sentinel.querySelector('a[rel="next"]');
          if (fallbackLink) fallbackLink.href = nextSentinel.dataset.nextUrl;
          sentinel.dataset.loading = 'false';
          observer.observe(sentinel);
        } else {
          sentinel.remove();
        }
      } catch (error) {
        sentinel.dataset.loading = 'false';
        window.setTimeout(() => observer.observe(sentinel), 1500);
      }
    };

    const initialize = () => {
      document.querySelectorAll(selector).forEach((sentinel) => {
        if (sentinel.dataset.infiniteReady === 'true') return;

        sentinel.dataset.infiniteReady = 'true';
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) loadNextPage(sentinel, observer);
            });
          },
          { rootMargin: '600px 0px' }
        );

        observer.observe(sentinel);
      });
    };

    initialize();
    new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
